import { teacherCurrentLiveClassAtom } from '@openeducation/oe-it-jotai-atoms';
import { useGetProfileConfig } from '@openeducation/oe-it-providers';
import type { PersonProfile } from '@openeducation/oe-it-shared-types';
import {
  SizeBreakpoint,
  styled,
  useDimension,
} from '@openeducation/oe-it-themes';
import { useAtomValue } from 'jotai';
import React from 'react';

import { useCurrentTeacherClass } from '../../hooks/use-current-teacher-class';
import { PortalPaths } from '../../interfaces/portal-paths.enum';
import { TeacherProfile } from '../../molecules/teacher-profile/teacher-profile';
import { WorkScheduleCard } from '../../molecules/work-schedule-card/work-schedule-card';
import { ActiveClassCard } from '../../organisms/active-class-card/active-class-card';
import { ClassFeedbackCard } from '../../organisms/class-feedback-card/class-feedback-card';
import { CurrentClassCard } from '../../organisms/current-class-card/current-class-card';
import { TeacherFeedbackCard } from '../../organisms/teacher-feedback-card/teacher-feedback-card';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';
export interface DashboardPageProps {
  teacherProfile: PersonProfile;
}

export const DashboardPage = ({ teacherProfile }: DashboardPageProps) => {
  const { isDesktop } = useDimension();
  const { data: wolverineConfig } = useGetProfileConfig();

  const classroomId = useAtomValue(teacherCurrentLiveClassAtom);
  const { currentClass } = useCurrentTeacherClass({ classroomId });
  return (
    <PortalLayout selectedPage={PortalPaths.Dashboard} title="Dashboard">
      <Container>
        <InformationContainer isDesktop={isDesktop}>
          <TeacherProfile
            accountName={teacherProfile.accountName}
            displayName={teacherProfile.displayName}
            facultyId={teacherProfile.w2wId}
            fullName={`${teacherProfile.firstName} ${teacherProfile.lastName}`}
            role={teacherProfile.roleDto.roleType}
            personId={teacherProfile.id}
          />
          <WorkScheduleCard />
        </InformationContainer>
        <CurrentClassCard
          teacherName={teacherProfile.displayName}
          currentClass={currentClass}
        />
        <ActiveClassCard teacherId={teacherProfile.id} />

        {wolverineConfig?.liveClassFeedbackEnabled && <ClassFeedbackCard />}
        <TeacherFeedbackCard />
      </Container>
    </PortalLayout>
  );
};

const Container = styled.View`
  gap: 32px;
  padding-bottom: 32px;
`;

interface InformationContainerProps {
  isDesktop: boolean;
}

const InformationContainer = styled.View<InformationContainerProps>`
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column-reverse')};
  justify-content: space-between;
  gap: 32px;
  max-width: ${SizeBreakpoint.XXXL}px;
`;
